module.exports = __webpack_public_path__ + "img/adobe-community-expert-badge.477c5d5.png";